/** Object whose keys are that of a given object type, with all values of a single specified type */
export type KeyObj<Obj extends Record<string, any>, ValueType> = {
  [_key in keyof Obj]: ValueType;
};

/**
 *
 * @param val
 * @param obj
 * @returns an object with the same keys as the passed-in object, with each field set to a given value.
 */
export const KEY_OBJECT = <Obj, Val>(obj: Obj, val: Val) => {
  let result: Partial<KeyObj<Obj, Val>> = {};

  for (let key of Object.keys(obj)) {
    result[key as keyof Obj] = val;
  }

  return result as KeyObj<Obj, Val>;
};
